import { BrowserRouter, Route, Routes } from "react-router-dom";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import PhosphorIconInit from "./helper/PhosphorIconInit";

import MainLayout from "./layouts/MainLayout";

import OrderConfirmPage from "./pages/OrderConfirmPage";
import HomePageOne from "./pages/HomePageOne";
import ShopPage from "./pages/ShopPage";
import ProductDetailsPageOne from "./pages/ProductDetailsPageOne";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import AccountPage from "./pages/AccountPage";
import ContactPage from "./pages/ContactPage";
import WishlistPage from "./pages/WishlistPage";
import AboutUsPage from "./pages/AboutUsPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsAndConditionsPage from "./pages/TermsAndConditionsPage";
import RefundPolicyPage from "./pages/RefundPolicyPage";
import HelpCenterPage from "./pages/HelpCenterPage";
import ShippingAndDeliveryPage from "./pages/ShippingAndDeliveryPage";
import ReturnsAndRefundsPage from "./pages/ReturnsAndRefundsPage";

import CustomerProtectedRoute from "./routes/CustomerProtectedRoute";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import LiveChatPage from "./pages/LiveChatPage";
import PayPalSuccessPage from "./pages/PayPalSuccessPage";
import PayPalCancelPage from "./pages/PayPalCancelPage";
import Developer from "./pages/Developer";

function App() {
  return (
    <BrowserRouter>
      <RouteScrollToTop />
      <PhosphorIconInit />

      <Routes>
        <Route element={<MainLayout />}>
          {/* Public */}
          <Route path="/" element={<HomePageOne />} />
          <Route path="/shop" element={<ShopPage />} />
          <Route path="/product-details/:id" element={<ProductDetailsPageOne />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/wishlist" element={<WishlistPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/about" element={<AboutUsPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-conditions" element={<TermsAndConditionsPage />} />
          <Route path="/refund-policy" element={<RefundPolicyPage />} />
          <Route path="/help-center" element={<HelpCenterPage />} />
          <Route path="/shipping" element={<ShippingAndDeliveryPage />} />
          <Route path="/returns" element={<ReturnsAndRefundsPage />} />

          {/* Auth pages */}
          <Route path="/login" element={<AccountPage />} />
          <Route path="/signup" element={<AccountPage />} />
          <Route path="/register" element={<AccountPage />} />

          {/* Forgot/Reset */}
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          <Route path="/order-confirm" element={<OrderConfirmPage />} />

          {/* Protected */}
          <Route element={<CustomerProtectedRoute />}>
            <Route path="/account" element={<AccountPage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/live-chat" element={<LiveChatPage />} />
          </Route>

          <Route path="/checkout/paypal/success" element={<PayPalSuccessPage />} />
          <Route path="/checkout/paypal/cancel" element={<PayPalCancelPage />} />
          <Route path="/developer" element={<Developer />}/>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;